import { useCallback, useSyncExternalStore } from "react";
import type { FieldUiOptions, QualityGuardFieldIssues } from "../types";

const unsubscribeNoop = () => {};

export function useQualityGuardFieldIssues(
  fieldUiOptions: FieldUiOptions | undefined,
  fieldId: string | undefined
): QualityGuardFieldIssues | null {
  const subscribe = useCallback(
    (listener: () => void) =>
      fieldUiOptions?.subscribeQualityGuardFieldIssues?.(listener) ?? unsubscribeNoop,
    [fieldUiOptions]
  );
  const getSnapshot = useCallback(() => {
    if (!fieldId) {
      return null;
    }
    return fieldUiOptions?.getQualityGuardFieldIssues?.({ fieldId }) ?? null;
  }, [fieldId, fieldUiOptions]);

  return useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
}
